import { SupervisionError } from "solar-bo";


export class OMItem{

    id:string;
    status: string;//pending, inprogess, ended etc
    reviewedDate: Date;
    comments: string;
    modify_date:Date;
    modify_user:string;
    image:any;
    operation:any;

    //issue
    issue: SupervisionError;
    id_issue:string;  
    panel_serial:string;  

    /**
     * Resturn description of the status based on code
     * @param status 
     * @returns 
     */
    public static getDescription(status:string){
      switch (status){

        case "TOREVIEW":
          return "To Review";  
        case "PENDING":
          return "Pending";
        case "INPROGRESS":
          return "In progress"; 
        case "REVIEWED":
          return "Reviewed";      
        default:
          return "Unknown";                         
      }
    }
  }